import React, { useState } from 'react'
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { TextField } from '@mui/material';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import { GLOBAL_URL } from '../../../API/global';
import { validateDoc, validatePdf } from '../../Helper';

const Documents = ({ formData, setFormData, errors, setDocumentErrors }) => {

    const [selectedScheduleProfile, setSelectedScheduleProfile] = useState(null);
    const [selectedCreatorProfile, setSelectedCreatorProfile] = useState(null);
    const [selectedDirectorProfile, setSelectedDirectorProfile] = useState(null);
    const [selectedProducerProfile, setSelectedProducerProfile] = useState(null);

    const handleChange = (e) => {
        const { name, value } = e.target;

        setFormData(prevData => ({
            ...prevData,
            [name]: value
        }));

        // Clear error for this field
        if (errors && errors[name] !== undefined) {
            setDocumentErrors({
                ...errors,
                [name]: ""
            });
        }
    };

    const handleSynopsisChange = (e) => {
        const { name, value } = e.target;

        // Count words in the current value
        const wordCount = value.trim() ? value.trim().split(/\s+/).length : 0;

        // If word count is less than or equal to 200, allow typing
        if (wordCount <= 200) {
            setFormData(prevData => ({
                ...prevData,
                [name]: value
            }));

            // Clear error
            if (errors && errors[name] !== undefined) {
                setDocumentErrors({
                    ...errors,
                    [name]: ""
                });
            }
        } else {
            // Show error when trying to exceed 200 words
            // setDocumentErrors({
            //     ...errors,
            //     synopsis: "Synopsis cannot exceed 200 words"
            // });
        }
    };

    const handleSelectedScheduleProfile = (event) => {
        const file = event.target.files[0];
        if (!file) return;

        const validateState = validatePdf(file);

        if (!validateState['status']) {
            setDocumentErrors({
                ...errors,
                schedule_1: validateState.message
            });
        } else {
            setSelectedScheduleProfile(file);
            setFormData((prevState) => ({
                ...prevState,
                schedule_1: file,
                is_schedule_one: 1,
            }));
            setDocumentErrors({
                ...errors,
                schedule_1: ''
            });
        }
    };

    const handleSelectedProfileOfCreator = (event) => {
        const file = event.target.files[0];
        if (!file) return;

        const validateState = validateDoc(file);

        if (!validateState['status']) {
            setDocumentErrors({
                ...errors,
                brief_profile_of_creator: validateState.message
            });
        } else {
            setSelectedCreatorProfile(file);
            setFormData((prevState) => ({
                ...prevState,
                brief_profile_of_creator: file,
                is_creator_profile: 1,
            }));
            setDocumentErrors({
                ...errors,
                brief_profile_of_creator: ''
            });
        }
    };

    const handleSelectedProfileOfDirector = (event) => {
        const file = event.target.files[0];
        if (!file) return;

        const validateState = validateDoc(file);

        if (!validateState['status']) {
            setDocumentErrors({
                ...errors,
                brief_profile_of_director: validateState.message
            });
        } else {
            setSelectedDirectorProfile(file);
            setFormData((prevState) => ({
                ...prevState,
                brief_profile_of_director: file,
                is_director_profile: 1,
            }));
            setDocumentErrors({
                ...errors,
                brief_profile_of_director: ''
            });
        }
    };

    const handleSelectedProfileOfProducer = (event) => {
        const file = event.target.files[0];
        if (!file) return;

        const validateState = validateDoc(file);

        if (!validateState['status']) {
            setDocumentErrors({
                ...errors,
                brief_profile_of_producer: validateState.message
            });
        } else {
            setSelectedProducerProfile(file);
            setFormData((prevState) => ({
                ...prevState,
                brief_profile_of_producer: file,
                is_brief_profile_of_producer: 1,
            }));
            setDocumentErrors({
                ...errors,
                brief_profile_of_producer: ''
            });
        }
    };

    // Get word count for synopsis
    const getWordCount = (text) => {
        if (!text) return 0;
        return text.trim() ? text.trim().split(/\s+/).length : 0;
    };

    return (
        <>
            <h5 className='mb-4'>
                8.Upload Documents and Other Details<span className="text-danger">*</span>
            </h5>

            <form>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={12} md={12} lg={12}>
                                <Box>
                                    <TextField
                                        variant="outlined"
                                        placeholder="(b) Synopsis of the web-series (Precise, not exceeding 200 words)"
                                        name="synopsis"
                                        multiline
                                        rows={4}
                                        value={formData?.synopsis || ''}
                                        onChange={handleSynopsisChange}
                                        InputProps={{
                                            style: {
                                                border: "1px solid #1c5768",
                                                borderRadius: "5px",
                                            },
                                        }}
                                        fullWidth
                                        helperText={`${getWordCount(formData?.synopsis)} / 200 words`}
                                        FormHelperTextProps={{
                                            style: {
                                                color: getWordCount(formData?.synopsis) >= 200 ? '#d32f2f' : '#666'
                                            }
                                        }}
                                        error={getWordCount(formData?.synopsis) > 200}
                                    />
                                    {errors?.synopsis && (
                                        <p className="text-danger">{errors.synopsis}</p>
                                    )}
                                    {/* {getWordCount(formData?.synopsis) > 200 && (
                                        <p className="text-danger" style={{ fontWeight: 'bold' }}>
                                            ⛔ You have exceeded the 200 word limit!
                                        </p>
                                    )} */}
                                    {/* <p className="text-warning" style={{ color: '#ed6c02' }}>
                                        ⚠️ Maximum 200 words reached
                                    </p> */}
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={12} md={6} lg={6}>
                                <Box>
                                    <input
                                        type="file"
                                        accept=".pdf"
                                        onChange={handleSelectedScheduleProfile}
                                        style={{ display: 'none', width: "100%" }}
                                        id="ScheduleProfile"
                                        name="schedule_1"
                                    />
                                    <label htmlFor="ScheduleProfile" style={{ width: "100%", height: "100%" }}>
                                        <TextField
                                            variant="outlined"
                                            placeholder="(a) Schedule 1"
                                            value={selectedScheduleProfile ? selectedScheduleProfile.name : ''}
                                            InputProps={{
                                                readOnly: true,
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        <IconButton
                                                            onClick={() => document.getElementById('ScheduleProfile').click()}
                                                            edge="end"
                                                        >
                                                            <AttachFileIcon />
                                                        </IconButton>
                                                    </InputAdornment>
                                                ),
                                                style: {
                                                    border: "1px solid #1c5768",
                                                    borderRadius: "5px",
                                                    height: "108px",
                                                },
                                            }}
                                            fullWidth
                                        />
                                        {errors?.schedule_1 && (
                                            <p className="text-danger">{errors.schedule_1}</p>
                                        )}
                                        {formData?.documentData?.[9] && (
                                            <div>
                                                <span className="Attach_Photo_ID">
                                                    <a href={`${GLOBAL_URL}downloadfile/ott/${formData.id}/${formData?.documentData?.[9].file}`}>
                                                        {formData?.documentData?.[9].name}
                                                    </a>
                                                </span>
                                            </div>
                                        )}
                                    </label>
                                </Box>
                            </Grid>

                            {/* Synopsis - Textarea with 200 word limit */}


                            <Grid item xs={12} sm={12} md={6} lg={6}>
                                <Box>
                                    <input
                                        type="file"
                                        accept=".doc,.docx"
                                        onChange={handleSelectedProfileOfCreator}
                                        style={{ display: 'none', width: "100%" }}
                                        id="profileOfCreator"
                                        name="brief_profile_of_creator"
                                    />
                                    <label htmlFor="profileOfCreator" style={{ width: "100%", height: "100%" }}>
                                        <TextField
                                            variant="outlined"
                                            placeholder="(c) Brief Profile of Creator(s) (Precise, not exceeding 200 words)"
                                            value={selectedCreatorProfile ? selectedCreatorProfile.name : ''}
                                            InputProps={{
                                                readOnly: true,
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        <IconButton
                                                            onClick={() => document.getElementById('profileOfCreator').click()}
                                                            edge="end"
                                                        >
                                                            <AttachFileIcon />
                                                        </IconButton>
                                                    </InputAdornment>
                                                ),
                                                style: {
                                                    border: "1px solid #1c5768",
                                                    borderRadius: "5px",
                                                    height: "108px",
                                                },
                                            }}
                                            fullWidth
                                        />
                                        {errors?.brief_profile_of_creator && (
                                            <p className="text-danger">{errors.brief_profile_of_creator}</p>
                                        )}
                                        {formData?.documentData?.[2] && (
                                            <div>
                                                <span className="Attach_Photo_ID">
                                                    <a href={`${GLOBAL_URL}downloadfile/ott/${formData.id}/${formData?.documentData?.[2].file}`}>
                                                        {formData?.documentData?.[2].name}
                                                    </a>
                                                </span>
                                            </div>
                                        )}
                                    </label>
                                </Box>
                            </Grid>

                            <Grid item xs={12} sm={12} md={6} lg={6}>
                                <Box>
                                    <input
                                        type="file"
                                        accept=".doc,.docx"
                                        onChange={handleSelectedProfileOfDirector}
                                        style={{ display: 'none', width: "100%" }}
                                        id="profileOfDirector"
                                        name="brief_profile_of_director"
                                    />
                                    <label htmlFor="profileOfDirector" style={{ width: "100%", height: "100%" }}>
                                        <TextField
                                            variant="outlined"
                                            placeholder="(d) Brief Profile of Director(s) (Precise, not exceeding 200 words)"
                                            value={selectedDirectorProfile ? selectedDirectorProfile.name : ''}
                                            InputProps={{
                                                readOnly: true,
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        <IconButton
                                                            onClick={() => document.getElementById('profileOfDirector').click()}
                                                            edge="end"
                                                        >
                                                            <AttachFileIcon />
                                                        </IconButton>
                                                    </InputAdornment>
                                                ),
                                                style: {
                                                    border: "1px solid #1c5768",
                                                    borderRadius: "5px",
                                                    height: "108px",
                                                },
                                            }}
                                            fullWidth
                                        />
                                        {errors?.brief_profile_of_director && (
                                            <p className="text-danger">{errors.brief_profile_of_director}</p>
                                        )}
                                        {formData?.documentData?.[3] && (
                                            <div>
                                                <span className="Attach_Photo_ID">
                                                    <a href={`${GLOBAL_URL}downloadfile/ott/${formData.id}/${formData?.documentData?.[3].file}`}>
                                                        {formData?.documentData?.[3].name}
                                                    </a>
                                                </span>
                                            </div>
                                        )}
                                    </label>
                                </Box>
                            </Grid>

                            <Grid item xs={12} sm={12} md={6} lg={6}>
                                <Box>
                                    <input
                                        type="file"
                                        accept=".doc,.docx"
                                        onChange={handleSelectedProfileOfProducer}
                                        style={{ display: 'none', width: "100%" }}
                                        id="profileOfProducer"
                                        name="brief_profile_of_producer"
                                    />
                                    <label htmlFor="profileOfProducer" style={{ width: "100%", height: "100%" }}>
                                        <TextField
                                            variant="outlined"
                                            placeholder="(e) Brief Profile of Producer(s) (Precise, not exceeding 200 words)"
                                            value={selectedProducerProfile ? selectedProducerProfile.name : ''}
                                            InputProps={{
                                                readOnly: true,
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        <IconButton
                                                            onClick={() => document.getElementById('profileOfProducer').click()}
                                                            edge="end"
                                                        >
                                                            <AttachFileIcon />
                                                        </IconButton>
                                                    </InputAdornment>
                                                ),
                                                style: {
                                                    border: "1px solid #1c5768",
                                                    borderRadius: "5px",
                                                    height: "108px",
                                                },
                                            }}
                                            fullWidth
                                        />
                                        {errors?.brief_profile_of_producer && (
                                            <p className="text-danger">{errors.brief_profile_of_producer}</p>
                                        )}
                                        {formData?.documentData?.[4] && (
                                            <div>
                                                <span className="Attach_Photo_ID">
                                                    <a href={`${GLOBAL_URL}downloadfile/ott/${formData.id}/${formData?.documentData?.[4].file}`}>
                                                        {formData?.documentData?.[4].name}
                                                    </a>
                                                </span>
                                            </div>
                                        )}
                                    </label>
                                </Box>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </form>

            {/* Section 9 - Online downloadable digital file as back-up copy */}
            <div className='row mt-5'>
                <div className='col-sm-12 col-lg-12'>
                    <h5 className='mb-4'>9. Online streaming link (only Vimeo or Google Drive or similar platform links acceptable)</h5>
                </div>

                <div className='col-sm-12 col-lg-12 mt-3'>
                    <div className='row'>
                        <div className='col-sm-12 col-lg-12'>
                            <p style={{ fontWeight: "500", color: "#615A5B" }}>
                                9.1 Online downloadable link <span className='text-danger'>*</span> :
                            </p>
                            <p style={{ fontSize: "14px", color: "#666" }}>
                                (vimeo/google drive link etc.)
                            </p>
                            <TextField
                                variant="outlined"
                                fullWidth
                                name="online_link"
                                placeholder="Enter online downloadable link (e.g., https://vimeo.com/xxxxx or https://drive.google.com/xxxxx)"
                                value={formData?.online_link || ''}
                                onChange={handleChange}
                                InputProps={{
                                    style: {
                                        backgroundColor: '#fff',
                                    }
                                }}
                            />
                            {errors?.online_link && (
                                <p className="text-danger">{errors.online_link}</p>
                            )}
                        </div>
                    </div>
                </div>

                <div className='col-sm-12 col-lg-12 mt-3'>
                    <div className='row'>
                        <div className='col-sm-12 col-lg-12'>
                            <p style={{ fontWeight: "500", color: "#615A5B" }}>
                                9.2 Password to open the link (if any) :
                            </p>
                            <TextField
                                variant="outlined"
                                fullWidth
                                name="online_password"
                                type="password"
                                placeholder="Enter password (if required)"
                                value={formData?.online_password || ''}
                                onChange={handleChange}
                                InputProps={{
                                    style: {
                                        backgroundColor: '#fff',
                                    }
                                }}
                            />
                            {errors?.online_password && (
                                <p className="text-danger">{errors.online_password}</p>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Documents